import { render, staticRenderFns } from "./ContactSelectionBubble.vue?vue&type=template&id=31891acc"
import script from "./ContactSelectionBubble.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactSelectionBubble.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports